import React from "react";
import "./panel.css";
import Partners from "../partners/Partners";
import Quotes from "../quotes/Quotes";

const Panel = ({ language }) => {
  return (
    <div className="panel">
      <div className="panel__top">
        <Quotes language={language} />
        <img src="img/wt-strongest.png" alt="Strongest in Lithuania" />
      </div>
      <Partners language={language} />
    </div>
  );
};

export default Panel;
